import { Component, Input } from "@angular/core";

@Component({
  selector: "app-collapse-component",
  templateUrl: "./collapse-component.component.html",
  styleUrls: ["./collapse-component.component.scss"],
  standalone: false
})
export class CollapseComponentComponent {
  expanded = false;
  @Input() text: string = "";
  @Input() collapseText: string = "";

  toggle(): void {
    this.expanded = !this.expanded;
  }
}
